import { Card, Form } from "react-bootstrap";

import GitchaLogo from "../../../images/gitcha-logo.svg";
import PremiumPlanModal from "../../../components/PlanUpgrade/PremiumPlanModal";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { useAppConfig } from "@/appConfig";
import { isSyndicationCheckedByDefault } from "@/helpers/tenant";

const styles = `
  .want-listing-syndication .wantad-type-wrap label.check-wrap span {
    border: 0px !important;
    background-color: transparent !important;
  }
  .want-listing-syndication .wantad-type-wrap label.check-wrap input[type="checkbox"]:checked + span {
    background-color: transparent !important;
    border: 0px
  }
  .want-listing-syndication .checkbox-label {
    font-weight: 400 !important;
    font-size: 16px !important;
    color: var(--neutral-950) !important;
  }
`


const WantListingSyndication = ({
  handleFormValues,
  wantAdData,
}) => {
  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails,
  );

  const [userDetails, setUserDetails] = useState(null);
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);

  const { flags } = useAppConfig();

  const showMLSFields = flags?.mlsAgentEditor;
  const syndicationDefault = isSyndicationCheckedByDefault();

  const PremiumPlanModalClose = () => setPremiumPlanModal(false);
  const PremiumPlanModalShow = () => setPremiumPlanModal(true);

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      setUserDetails(userDetailsFromStore[0]);
    } else {
      setUserDetails(null);
    }
  }, [userDetailsFromStore]);

  useEffect(() => {
    if (showMLSFields && wantAdData?.syndicateToThePublic === undefined) {
      handleFormValues({ syndicateToThePublic: syndicationDefault });
    }
  }, [showMLSFields, syndicationDefault, wantAdData?.syndicateToThePublic]);

  if (!showMLSFields) return null;

  return (
    <>
      <style>{styles}</style>
      <Card className="mb-4 border-0 want-listing-syndication">
        <Card.Header className="p-0 border-0">
          <Card.Title className="want-listing-syndication__head">
            Want-Listing Syndication
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-0 want-listing-wrapper">
          <Form.Group>
            <div className="wantad-type-wrap pb-0 mt-3">
              <div className="row">
                <label className={"check-wrap mb-3"}>
                  <input
                    type="checkbox"
                    name="property_checkbox"
                    checked={wantAdData?.syndicateToThePublic ?? syndicationDefault}
                    onChange={(e) => {
                      handleFormValues({
                        syndicateToThePublic: e.target.checked,
                      });
                    }}
                  />
                  <span style={{ paddingTop: '0px', paddingLeft: '0px', userSelect: 'none' }}>
                    <div className="wantad-type-info">
                      <h2 className={"pb-0 checkbox-label"} style={{ display: 'inline' }}>
                        Syndicate to the public via
                        <img src={GitchaLogo}
                          alt="Gitcha"
                          style={{
                            display: 'inline',
                            verticalAlign: 'middle',
                            width: '60px',
                            marginBottom: '6px',
                            marginTop: '0px',
                            marginLeft: '5px'
                          }} />
                      </h2>
                    </div>
                  </span>
                </label>
              </div>
            </div>
          </Form.Group>
        </Card.Body>
      </Card>
      <PremiumPlanModal
        userDetails={userDetails}
        show={showPremiumPlanModal}
        onHide={PremiumPlanModalClose}
        showPlanModal={PremiumPlanModalShow}
      />
    </>
  );
};

export default WantListingSyndication;
